import { CreditMemo } from '../model/models';
import { sumMonies } from './money-operations';
import { CurrencyCode, Money } from '../model/models';

// TODO: This function exists because of a bug in financing-graphql that is causing credit memos to be returned as allocations
// instead of distinct credit memos. This issue needs to be addressed so we can stop relying on the FE to "fix" the data
export function deDuplicatePendingCreditMemos(pendingCreditMemos: CreditMemo[]): CreditMemo[] {
    let creditMemoIds = {};
    let deduplicatedCreditMemos = [];

    pendingCreditMemos.forEach((creditMemo) => {
        if (creditMemoIds[creditMemo.id]) {
            let existingCreditMemo = deduplicatedCreditMemos[creditMemoIds[creditMemo.id] - 1];

            existingCreditMemo.allocatedAmount = sumMonies([
                existingCreditMemo.allocatedAmount,
                creditMemo.allocatedAmount
            ]);
        } else {
            creditMemoIds[creditMemo.id] = deduplicatedCreditMemos.push(creditMemo);
        }
    });

    return deduplicatedCreditMemos;
}

// Add up the total remaining amount
// TODO: Switch to the remainingAmount field from graphql once thats deployed
export function calculateTotalRemainingAmount(creditMemos: CreditMemo[]): Money {
    if (creditMemos.length == 0) {
        return {
            cents: 0,
            currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE
        };
    }

    let totalRemainingAmount = {
        cents: 0,
        currencyCode: creditMemos[0].amount.currencyCode
    };

    creditMemos.forEach((creditMemo) => {
        totalRemainingAmount = sumMonies([
            totalRemainingAmount,
            sumMonies([creditMemo.amount, creditMemo.allocatedAmount])
        ]);
    });

    return totalRemainingAmount;
}

export function calculateAmount(creditMemos: CreditMemo[]): Money {
    if (creditMemos.length == 0) {
        return {
            cents: 0,
            currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE
        };
    }

    let amount = {
        cents: 0,
        currencyCode: creditMemos[0].amount.currencyCode
    };

    creditMemos.forEach((creditMemo) => {
        amount = sumMonies([amount, creditMemo.amount]);
    });

    return amount;
}
